<template>
  <Loader v-if="!isLoaded"/>
  <div v-else>
<!--    <div class="with-side-panel">-->
<!--      <div class="content-i">-->
<!--        <div class="content-box">-->
<!--          <div class="element-wrapper">-->
<!--            <div class="d-flex justify-content-between">-->
<!--              <h6 class="element-header">-->
<!--                {{ $t('user.title') }}-->
<!--                <span v-if="userId"> - -->
<!--                {{ userData?.firstName }}-->
<!--                {{ userData?.lastName }}-->
<!--                ({{ userData?.engagementTypeTranslation }})-->
<!--              </span>-->
<!--              </h6>-->

<!--&lt;!&ndash;              <CreateButton&ndash;&gt;-->
<!--&lt;!&ndash;                  :label="$t('general.button.back')"&ndash;&gt;-->
<!--&lt;!&ndash;                  :to="{ name: 'userList' }">&ndash;&gt;-->
<!--&lt;!&ndash;              </CreateButton>&ndash;&gt;-->
<!--            </div>-->

<!--            <div class="element-box">-->
<!--              <UserMenu :userId="userId" :employeeType="employeeType"/>-->

<!--              <p class="mt-5"><span style="font-weight: bold">Name</span>:&nbsp;&nbsp; {{ userData?.firstName }}-->
<!--                {{ userData?.lastName }}</p>-->
<!--              <p class="mt-2"><span style="font-weight: bold">Email</span>:&nbsp;&nbsp; {{ userData?.email }}</p>-->
<!--              <p class="mt-2"><span style="font-weight: bold">Wö. Arbeitszeit</span>:&nbsp;&nbsp;-->
<!--                {{ userData?.workingHours }}</p>-->
<!--              <p class="mt-2"><span style="font-weight: bold">Wö. Arbeitsminuten</span>:&nbsp;&nbsp;-->
<!--                {{ userData?.workingMinutes }}</p>-->
<!--              <p class="mt-2"><span style="font-weight: bold">Eintrittstermin</span>:&nbsp;&nbsp;-->
<!--                {{ userData?.startingDate }}</p>-->
<!--              <p class="mt-2"><span style="font-weight: bold">Entlohnung</span>:&nbsp;&nbsp; {{ userData?.pay }}</p>-->

<!--              <p class="mt-2"><span style="font-weight: bold">Arbeitstage</span>:&nbsp;&nbsp;-->
<!--                <span v-for="(day, index) in userData?.workingDays" :key="'user-' + index">-->
<!--                  {{ day }}<span v-if="index !== userData?.workingDays?.length - 1">,&nbsp;</span>-->
<!--                </span>-->
<!--              </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script setup>
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import {ErrorToast} from '@/components/VueToast';
import UserMenu from '@/views/App/User/UserMenu.vue';
import {onMounted, ref} from 'vue';
import {useRoute} from "vue-router";
import userService from "@/api/User";

const isLoaded = ref(false);
const route = useRoute();
const userId = route.params.id;
const userData = ref([])
const employeeType = ref("")

async function getUser() {
  try {
    const {data} = await userService.getUser(+userId);
    const {user} = data.data;
    userData.value = user;
    employeeType.value = user.employeeType
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getUser();
  isLoaded.value = true;
});


</script>

<style scoped>
</style>